import { resolveIdDescriptor, resolveMinMax, resolveMinMaxDescription } from '../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    day,
    month,
    minYear,
    maxYear,
    region,
    country,
    area,
    minLatitude,
    maxLatitude,
    minLongitude,
    maxLongitude,
    minEqMagnitude,
    maxEqMagnitude,
    minIntensity,
    maxIntensity,
    minEqDepth,
    maxEqDepth,
    minDeaths,
    maxDeaths,
    minDeathsAmountOrder,
    maxDeathsAmountOrder,
    minDamageMillionsDollars,
    maxDamageMillionsDollars,
    minDamageAmountOrder,
    maxDamageAmountOrder,
    assocVol,
    assocTsu,
    minDeathsTotal,
    maxDeathsTotal,
    minDeathsAmountOrderTotal,
    maxDeathsAmountOrderTotal,
    locStart,
    locMatch,
    locInclude,
    locNot,
    commentsStart,
    commentsMatch,
    commentsInclude,
    commentsNot,
  },
  regions,
  peopleDescriptors,
  damageDescriptors,
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  if (day != null) {
    messages.push(`Day = ${day}`);
  }

  if (month != null) {
    messages.push(`Month = ${month}`);
  }

  resolveMinMax('ID', minId, maxId, messages);
  resolveMinMax('Year', minYear, maxYear, messages);

  if (region != null) {
    messages.push(`Region = ${resolveIdDescriptor(regions, region)}`);
  }

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (area != null) {
    messages.push(`Area = ${area}`);
  }

  if (locStart != null) {
    messages.push(`Location starts with '${locStart}'`);
  }

  if (locMatch != null) {
    messages.push(`Location = '${locMatch}'`);
  }

  if (locInclude != null) {
    messages.push(`Location contains '${locInclude}'`);
  }

  if (locNot != null) {
    messages.push(`Location != '${locNot}'`);
  }

  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);
  resolveMinMax('Longitude', minLongitude, maxLongitude, messages);
  resolveMinMax('Earthquake Magnitude', minEqMagnitude, maxEqMagnitude, messages);
  resolveMinMax('Earthquake Intensity', minIntensity, maxIntensity, messages);
  resolveMinMax('Earthquake Depth', minEqDepth, maxEqDepth, messages);

  if (assocVol != null) {
    messages.push(`Has associated volcano event = ${assocVol}`);
  }

  if (assocTsu != null) {
    messages.push(`Has associated tsunami = ${assocTsu}`);
  }

  resolveMinMax('Deaths', minDeaths, maxDeaths, messages);
  resolveMinMaxDescription('Deaths Description', minDeathsAmountOrder, maxDeathsAmountOrder, peopleDescriptors, messages);
  resolveMinMax('Damage Millions $', minDamageMillionsDollars, maxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Damage Description', minDamageAmountOrder, maxDamageAmountOrder, damageDescriptors, messages);
  resolveMinMax('Total Deaths', minDeathsTotal, maxDeathsTotal, messages);
  resolveMinMaxDescription('Total Deaths Description', minDeathsAmountOrderTotal, maxDeathsAmountOrderTotal, peopleDescriptors, messages);

  if (commentsStart != null) {
    messages.push(`Comments start with '${commentsStart}'`);
  }

  if (commentsMatch != null) {
    messages.push(`Comments = '${commentsMatch}'`);
  }

  if (commentsInclude != null) {
    messages.push(`Comments contains '${commentsInclude}'`);
  }

  if (commentsNot != null) {
    messages.push(`Comments != '${commentsNot}'`);
  }

  return messages;
};
